import { Typography as MuiTypography, TypographyProps } from '@mui/material';

const TypographyCustom = ({
  children,
  variant,
  color,
  ...props
}: Omit<TypographyProps, 'variant'> & {
  children: React.ReactNode;
  variant?: 'labelSmall' | 'labelMedium' | 'paragraphMedium' | 'h6';
  color?: string;
}) => {
  return (
    <MuiTypography variant={variant as TypographyProps['variant']} color={color} {...props}>
      {children}
    </MuiTypography>
  );
};

export default TypographyCustom;
